import styled, { css, RuleSet } from 'styled-components';
import { Typography } from '../../Typography';

export const ErrorWrapper = styled.div<{
  $margin: string | number;
  styles?: RuleSet<object>;
}>`
  margin-bottom: ${({ $margin }) =>
    typeof $margin === 'string' ? $margin : `${$margin}px`};

  ${({ styles }) => styles};
`;

export const Divider = styled.div<{ $isError: boolean }>`
  height: 1px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};

  ${({ $isError }) =>
    $isError &&
    css`
      border-color: ${({ theme }) => theme.colors.systemColors.red};
    `}
`;

export const ErrorText = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.red};
`;
